/*!
 * @prodabel/vue-keycloak-adapter v3.2.2
 * (c) @prodabel
 * Released under the MIT License.
 */
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var keycloakjs = require('keycloak-js');
var Vue = require('vue');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var keycloakjs__default = /*#__PURE__*/_interopDefaultLegacy(keycloakjs);
var Vue__default = /*#__PURE__*/_interopDefaultLegacy(Vue);

var store = {
  state: {
    BACKEND_URL: "",
    REDIRECT_URL_LOGOUT: "",
    USERINFO_ENDPOINT: "userinfo",
    VERBOSE: true,
    user: {},
    userProfile: {},
    userInfo: {},
    token: "",
    tokenParsed: null,
    refreshToken: "",
    status: "",
    keycloak: null
  },
  mutations: {
    //-------------- constantes
    SET_BACKEND_URL: function SET_BACKEND_URL(state, BACKEND_URL) {
      state.BACKEND_URL = BACKEND_URL;
    },
    SET_REDIRECT_URL_LOGOUT: function SET_REDIRECT_URL_LOGOUT(state, REDIRECT_URL_LOGOUT) {
      state.REDIRECT_URL_LOGOUT = REDIRECT_URL_LOGOUT;
    },
    SET_USERINFO_ENDPOINT: function SET_USERINFO_ENDPOINT(state, USERINFO_ENDPOINT) {
      state.USERINFO_ENDPOINT = USERINFO_ENDPOINT;
    },
    SET_VERBOSE: function SET_VERBOSE(state, VERBOSE) {
      state.VERBOSE = VERBOSE;
    },
    //-------------- keycloak
    setUser: function setUser(state, user) {
      state.user = user;
    },
    SET_KEYCLOAK: function SET_KEYCLOAK(state, keycloak) {
      state.token = keycloak.token;
      state.tokenParsed = keycloak.tokenParsed;
      state.refreshToken = keycloak.refreshToken;
      state.keycloak = keycloak;
      window.k = keycloak;
    },
    AUTH_REQUEST: function AUTH_REQUEST(state) {
      state.status = "loading";
    },
    AUTH_SUCCESS: function AUTH_SUCCESS(state) {
      var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      state.status = "success";
      state.token = token || state.token;
    },
    AUTH_ERROR: function AUTH_ERROR(state) {
      state.status = "error";
    },
    AUTH_LOGOUT: function AUTH_LOGOUT(state) {
      state.status = "logged_out";
      state.user = null;
      state.token = null;

      if (window.refresh_interval) {
        clearInterval(window.refresh_interval);
      }
    }
  },
  actions: {
    //-------------- constantes
    SET_BACKEND_URL: function SET_BACKEND_URL(_ref, BACKEND_URL) {
      var commit = _ref.commit;
      commit("SET_BACKEND_URL", BACKEND_URL);
    },
    SET_REDIRECT_URL_LOGOUT: function SET_REDIRECT_URL_LOGOUT(_ref2, REDIRECT_URL_LOGOUT) {
      var commit = _ref2.commit;
      commit("SET_REDIRECT_URL_LOGOUT", REDIRECT_URL_LOGOUT);
    },
    SET_USERINFO_ENDPOINT: function SET_USERINFO_ENDPOINT(_ref3, USERINFO_ENDPOINT) {
      var commit = _ref3.commit;
      commit("SET_USERINFO_ENDPOINT", USERINFO_ENDPOINT);
    },
    SET_VERBOSE: function SET_VERBOSE(_ref4, VERBOSE) {
      var commit = _ref4.commit;
      commit("SET_VERBOSE", VERBOSE);
    },
    //-------------- keycloak
    SET_KEYCLOAK: function SET_KEYCLOAK(_ref5, keycloak) {
      var state = _ref5.state,
          commit = _ref5.commit;
      commit("SET_KEYCLOAK", keycloak);
      return new Promise(function (resolve, reject) {
        // soh tento recuperar userinfo se estiver autenticada
        if (keycloak.authenticated) {
          var promiseInfo = keycloak.loadUserInfo();
          var promiseProfile = keycloak.loadUserProfile();
          Promise.all([promiseInfo, promiseProfile]).then(function (values) {
            Vue__default["default"].set(state, "userInfo", values[0]);
            Vue__default["default"].set(state, "userProfile", values[1]);
            resolve(keycloak);
          })["catch"](function (err) {
            reject(err);
          });
        } else {
          resolve(keycloak);
        }
      });
    },
    REFRESH_TOKEN: function REFRESH_TOKEN(_ref6) {
      var state = _ref6.state,
          dispatch = _ref6.dispatch;
      var seconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30;
      return new Promise(function (resolve, reject) {
        state.keycloak.updateToken(seconds).then(function (refreshed) {
          if (refreshed) {
            dispatch("SET_KEYCLOAK", state.keycloak).then(function () {
              resolve(refreshed);
            })["catch"](function (err) {
              reject(err);
            });
          } else {
            resolve(refreshed);
          }
        })["catch"](function (err) {
          console.error(err);
          reject(JSON.stringify({
            response: {
              status: 403,
              message: "Unauthorized",
              err: err
            }
          }));
        });
      });
    },
    AUTH_REQUEST: function AUTH_REQUEST(_ref7, _ref8) {
      var commit = _ref7.commit,
          dispatch = _ref7.dispatch;
      var token = _ref8.token,
          options = _ref8.options;
      commit("AUTH_REQUEST");
      commit("AUTH_SUCCESS", token);
      return dispatch("USER_REQUEST", options);
    },
    USER_REQUEST: function USER_REQUEST(_ref9, options) {
      var state = _ref9.state,
          commit = _ref9.commit,
          dispatch = _ref9.dispatch;
      commit("AUTH_REQUEST");
      return new Promise(function (resolve, reject) {
        dispatch("REFRESH_TOKEN").then(function () {
          sendXHR({
            state: state,
            commit: commit,
            dispatch: dispatch,
            options: options,
            resolve: resolve,
            reject: reject
          });
        })["catch"](function (err) {
          reject(err);
        });
      });
    },
    LOGOUT_REQUEST: function LOGOUT_REQUEST(_ref10) {
      var state = _ref10.state,
          commit = _ref10.commit;
      commit("AUTH_REQUEST");
      return new Promise(function (resolve) {
        commit("AUTH_LOGOUT");
        var options = {};

        if (state.REDIRECT_URL_LOGOUT) {
          options.redirectUri = state.REDIRECT_URL_LOGOUT;
        }

        state.keycloak.logout(options);
        resolve();
      });
    }
  },
  getters: {
    //-------------- keycloak
    token: function token(state) {
      return state.token;
    },
    tokenParsed: function tokenParsed(state) {
      return state.tokenParsed;
    },
    refreshToken: function refreshToken(state) {
      return state.refreshToken;
    },
    userInfo: function userInfo(state) {
      return state.userInfo;
    },
    userProfile: function userProfile(state) {
      return state.userProfile;
    },
    clientId: function clientId(state) {
      return state.keycloak ? state.keycloak.clientId : null;
    },
    userRoles: function userRoles(state) {
      if (state.tokenParsed && state.keycloak.clientId && state.tokenParsed.resource_access) return state.tokenParsed.resource_access[state.keycloak.clientId] ? state.tokenParsed.resource_access[state.keycloak.clientId]["roles"] : state.tokenParsed.resource_access;
      return [];
    },
    isAuthenticated: function isAuthenticated(state) {
      return !!state.token;
    },
    authStatus: function authStatus(state) {
      return state.status;
    },
    backendInfo: function backendInfo(state) {
      if (state.user && state.keycloak.clientId && state.user.resource_access) return {
        user: state.user,
        roles: state.user.resource_access[state.keycloak.clientId] ? state.user.resource_access[state.keycloak.clientId]["roles"] : state.user.resource_access
      };
      return {};
    },
    keycloak: function keycloak(state) {
      return state.keycloak;
    }
  }
};

var sendXHR = function sendXHR(_ref11) {
  var state = _ref11.state,
      commit = _ref11.commit,
      dispatch = _ref11.dispatch,
      options = _ref11.options,
      reject = _ref11.reject,
      resolve = _ref11.resolve;
  var xhr = new XMLHttpRequest();

  if (!xhr) {
    return state.VERBOSE ? "[Erro] Não foi possível criar uma instância XMLHTTP." : "";
  }

  xhr.onload = function () {
    if (xhr.status >= 200 && xhr.status < 300) {
      var data;

      try {
        data = JSON.parse(xhr.responseText);
      } catch (_unused) {
        data = "";
      }

      commit("AUTH_SUCCESS");
      commit("setUser", data.user); // Server Side Event: o server enviará informações do usuário, quando julgar pertinente

      if (options && options.sse) {
        if (state.VERBOSE) console.log("[VUE_KEYCLOAK] Utilizando SSE ao invés de setTimeout recursivo!!");
        var evtSource = new EventSource("".concat(state.BACKEND_URL, "/api/userinfo-sse?token=").concat(state.keycloak.token), {
          withCredentials: true
        });
        evtSource.addEventListener("message", function (event) {
          var data = JSON.parse(event.data);
          resolve(data);
          commit("setUser", data);
        }, false);
        evtSource.addEventListener("error", function (event) {
          if (event.target.readyState == 2) {
            if (state.VERBOSE) console.log("[VUE_KEYCLOAK][ERRO] Seu token sofreu refresh? Tentando novamente...");
            evtSource.close();
            dispatch("USER_REQUEST", options);
          }
        }, false); // AJAX polling (DEFAULT): o cliente enviará requisições ao servidor a cada (options.seconds_to_refresh) segundos
      } else if (options && options.seconds_to_refresh >= 0) {
        setTimeout(function () {
          resolve(data);
          dispatch("USER_REQUEST", options);
        }, options.seconds_to_refresh * 1000);
      }
    }
  };

  xhr.onerror = function () {
    commit("AUTH_ERROR");
    if (state.VERBOSE) console.log("[VUE_KEYCLOAK][ERRO] Tentando novamente...");
    setTimeout(function () {
      dispatch("USER_REQUEST", options);
    }, options.seconds_to_refresh * 1000);
    reject(xhr.responseText);
  };

  var url = state.BACKEND_URL + "/api/" + state.USERINFO_ENDPOINT;

  try {
    xhr.open("GET", url, true);
    xhr.withCredentials = true;
    xhr.setRequestHeader("Authorization", "Bearer " + state.keycloak.token);
    xhr.send(null);
  } catch (e) {
    return state.VERBOSE ? "[Erro] Não foi possível enviar a requisição XMLHTTP. " + e : "";
  }
};

var can = function can(name, permissions, roles) {
  if (!permissions) return false;
  if (Object.keys(permissions).length === 0) return false;
  if (!roles) return false;
  if (permissions.guest && permissions.guest.includes(name)) return true; //iterando no array de roles do usuario logado

  for (var i = 0; i < roles.length; i++) {
    //se no array de permissoes existe o recurso 'name' para o role iterado
    if (permissions[roles[i]]) {
      if (permissions[roles[i]].includes(name)) {
        return true;
      }
    }
  }

  return false;
};

var authorize = function authorize(to, next) {
  if (to.hash && !to.hash.includes('error=login_required')) {
    // rota liberada
    next(Object.assign({}, to, {
      hash: ''
    }));
  } else {
    // rota liberada
    next();
  }
};

var unauthorize = function unauthorize(from, next, options) {
  var error = new Error(JSON.stringify({
    response: {
      status: 403,
      message: 'Unauthorized'
    }
  }));
  options.authErrorCallback ? options.authErrorCallback(error) : console.error(error);
  next(false);
};

var findOrMatch = function findOrMatch(array, route) {
  var to = route.to || route.name || route.path || ""; // testa o to (ou path), se positivo, retorna direto

  if (array && to && array.includes(to)) return true; // se nao deu match exato, itera sobre as permissoes, 
  // aquelas q tiverem regex, testa a rota corrente
  // se a a rota corrente der match na regex, retorna positivo

  for (var key in array) {
    if (array[key].startsWith("regex::")) {
      var regex = new RegExp(array[key].replace("regex::", ""));
      if (regex.test(to)) return true;
    }
  }

  return false;
};

var routeIsAny = function routeIsAny(to, options) {
  return findOrMatch(options.permissions.any, to);
};

var routeIsGuest = function routeIsGuest(to, options) {
  return findOrMatch(options.permissions.guest, to);
};

var routeIsLogged = function routeIsLogged(to, options) {
  return findOrMatch(options.permissions.logged, to);
};

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

function _empty() {}

function _awaitIgnored(value, direct) {
  if (!direct) {
    return value && value.then ? value.then(_empty) : Promise.resolve();
  }
}

function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

function _continueIgnored(value) {
  if (value && value.then) {
    return value.then(_empty);
  }
}

function _invokeIgnored(body) {
  var result = body();

  if (result && result.then) {
    return result.then(_empty);
  }
}

function install(Vue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!options.store && options.verbose) throw new Error('[VUE_KEYCLOAK][ERROR]: Por favor forneça a store!!');
  if (!options.router && options.verbose) throw new Error('[VUE_KEYCLOAK][ERROR]: Por favor forneça o router!!');

  if (!options.redirect_url_logout) {
    options.redirect_url_logout = null;
    if (options.verbose) console.log('[VUE_KEYCLOAK] A redirect_url_logout não foi fornecida. Utilizando a default: \'' + options.redirect_url_logout + '\'');
  }

  if (!options.permissions) {
    options.permissions = {};
    if (options.verbose) console.log('[VUE_KEYCLOAK] As permissions não foram fornecidas. Utilizando a default: {}');
  }

  if (!options.seconds_to_refresh) {
    options.seconds_to_refresh = 10;
    if (options.verbose) console.log('[VUE_KEYCLOAK] Os seconds_to_refresh não foram fornecidos. Utilizando o default: 10');
  }

  if (!options.autorefresh_max_attempts) {
    options.autorefresh_max_attempts = -1; // infinito

    if (options.verbose) console.log('[VUE_KEYCLOAK] O autorefresh_max_attempts não foi fornecido. Utilizando o default: -1 (infinito).');
  }

  if (!options.backend_url) {
    if (options.verbose) console.log('[VUE_KEYCLOAK] A backend_url não foi fornecida. Exemplo: \'http://localhost:8000\'');
  }

  if (!options.userinfo_endpoint) {
    if (options.verbose) console.log('[VUE_KEYCLOAK] O userinfo_endpoint não foi fornecido. Exemplo: \'userinfo\'');
  }

  if (!Object.prototype.hasOwnProperty.call(options, "sse")) {
    options.sse = false;
    if (options.verbose) console.log('[VUE_KEYCLOAK] O sse não foi setado. Utilizando o default: \'false\'');
  }

  if (!Object.prototype.hasOwnProperty.call(options, "authorize_disabled")) {
    options.authorizeDisabled = false;
    if (options.verbose) console.log('[VUE_KEYCLOAK] O authorize_disabled não foi setado. Utilizando o default: \'false\'');
  }

  if (!Object.prototype.hasOwnProperty.call(options, "autorefresh_disabled")) {
    options.authorizeDisabled = false;
    if (options.verbose) console.log('[VUE_KEYCLOAK] O autorefresh_disabled não foi setado. Utilizando o default: \'false\'');
  }

  if (Object.prototype.hasOwnProperty.call(options.router, "beforeEach")) {
    if (options.verbose) {
      console.log('[VUE_KEYCLOAK] O pacote vue-keycloak-adapter sobrescreverá a função beforeEach da aplicação para realizar a lógica de autorização e autenticação.');
      console.log('[VUE_KEYCLOAK] Para desabilitar esse comportamento, é necessário setar authorize_disabled: false.');
    }
  }

  if (Object.prototype.hasOwnProperty.call(options.router, "afterEach")) {
    if (options.verbose) {
      console.log('[VUE_KEYCLOAK] O pacote vue-keycloak-adapter sobrescreverá a função afterEach da aplicação para realizar a lógica de autorização e autenticação.');
      console.log('[VUE_KEYCLOAK] Para desabilitar esse comportamento, é necessário setar authorize_disabled: false.');
    }
  }

  options.router.getRoutes().forEach(function (route) {
    if (route.beforeEnter && options.verbose) {
      console.log("[VUE_KEYCLOAK] A fun\xE7\xE3o beforeEnter na rota ".concat(route.name, " pode apresentar um comportamento indesejado, uma vez que o pacote vue-keycloak-adapter implementa (na fun\xE7\xE3o beforeEach) uma l\xF3gica de controle de fluxo."));
      console.log('[VUE_KEYCLOAK] Para desabilitar esse comportamento, é necessário setar authorize_disabled: false.');
    }
  });
  options.store.registerModule('keycloakstore', store);
  Vue.mixin({
    methods: {
      can: function can$1(name) {
        return can(name, options.permissions, options.store.getters.userRoles);
      }
    }
  }); // cria novo objeto Keycloak e salva-o na store

  var makeKeycloak = _async(function (options) {
    if (options.verbose) console.log('[VUE_KEYCLOAK] Iniciando o keycloak com as propriedades: ', options.options);
    var keycloak = new keycloakjs__default["default"](options.optionsConst);
    return _await(keycloak.init(options.options), function () {
      // seta configuracoes
      options.store.dispatch('SET_REDIRECT_URL_LOGOUT', options.redirect_url_logout);
      options.store.dispatch('SET_VERBOSE', options.verbose); // seta keycloak, carrega userInfo e userProfile

      return _await(options.store.dispatch('SET_KEYCLOAK', keycloak), function () {
        if (keycloak.authenticated) {
          // chamada ao userinfo do backend
          if (options.backend_url && options.userinfo_endpoint) {
            options.store.dispatch('SET_BACKEND_URL', options.backend_url);
            options.store.dispatch('SET_USERINFO_ENDPOINT', options.userinfo_endpoint);
            options.store.dispatch('AUTH_REQUEST', {
              token: keycloak.token,
              options: {
                seconds_to_refresh: options.seconds_to_refresh,
                sse: options.sse
              }
            });
          }

          if (!options.autorefresh_disabled) {
            var max_attempts = options.autorefresh_max_attempts;
            var curr_attempt = 1;
            window.refresh_interval = setInterval(_async(function () {
              return _catch(function () {
                if (max_attempts == -1 || curr_attempt <= max_attempts) {
                  return _awaitIgnored(options.store.dispatch("REFRESH_TOKEN"));
                } else {
                  clearInterval(window.refresh_interval);
                  throw new Error('autorefresh_max_attempts excedido! Vou parar de tentar fazer refresh do token...');
                }
              }, function (e) {
                curr_attempt++;

                if (options.refreshErrorCallback) {
                  options.refreshErrorCallback(e);
                } else {
                  if (options.verbose) console.log('[VUE_KEYCLOAK][ERROR]: ', e);
                }
              });
            }), options.seconds_to_refresh * 1000);
          }
        }

        return keycloak;
      });
    });
  }); // logica de autenticacao e autorizacao com perfis

  options.router.beforeEach(_async(function (to, from, next) {
    var store_getters = options.store.getters;
    var isAny = routeIsAny(to, options);
    var isGuest = routeIsGuest(to, options); // seta defaults e sobrescreve, se for o caso

    options.options = Object.assign({
      onLoad: "login-required",
      prompt: 'none',
      checkLoginIframe: false,
      pkceMethod: 'S256'
    }, options.options); // se ja tem um objeto keycloak iniciado na store, use-o (roteamento da SPA)

    return _invokeIgnored(function () {
      if (store_getters.keycloak) {
        var authenticated = store_getters.keycloak && store_getters.isAuthenticated;
        if (options.verbose) console.log('[VUE_KEYCLOAK] Status de autenticado: ', authenticated); // se estiver autenticado

        if (authenticated) {
          if (isAny) {
            authorize(to, next); // rotas guest, proibe, caso esteja autenticado
          } else if (isGuest) {
            unauthorize(from, next, options);
          } else {
            // aplica logica de autorizacao
            var isLogged = routeIsLogged(to, options);
            var yesICan = can(to.name, options.permissions, options.store.getters.userRoles);

            if (isLogged || yesICan) {
              // rotas do tipo logged e perfis permitidos
              authorize(to, next);
            } else {
              // se nao for rota do tipo logged ou o perfil nao puder acessar
              unauthorize(from, next, options);
            } // await doAuthorization(to, from, next, options)

          }
        } else {
          //deixa o afterEach resolver
          authorize(to, next);
        }
      } else {
        return _continueIgnored(_catch(function () {
          // rotas any e guest iniciam o objeto sem 'login-required'
          if (isAny || isGuest) {
            options.options = {};
          } // cria novo objeto keycloak e guarda na store


          return _await(makeKeycloak(options), function () {
            authorize(to, next);
          });
        }, function (error) {
          if (isAny || isGuest) {
            authorize(to, next);
          } else {
            if (options.verbose) console.log('[VUE_KEYCLOAK][ERROR]: ', error);
            unauthorize(from, next, options);
          }
        }));
      }
    });
  })); // como rotas any e guest estao liberadas sem autenticacao
  // eh necessario criar o objeto keycloak depois de entrar na pagina
  // para cria-lo com o parametro redirectUri correto

  options.router.afterEach(_async(function (to) {
    var store_getters = options.store.getters;
    var isAny = routeIsAny(to, options);
    var isGuest = routeIsGuest(to, options);
    return _invokeIgnored(function () {
      if (store_getters.keycloak) {
        var authenticated = store_getters.keycloak && store_getters.isAuthenticated; // se nao estiver autenticado

        return _invokeIgnored(function () {
          if (!authenticated) {
            // rotas any e guest estao liberadas
            return _invokeIgnored(function () {
              if (!isAny && !isGuest) {
                return _continueIgnored(_catch(function () {
                  // cria novo objeto keycloak e guarda na store (havera um reload da pagina)
                  return _awaitIgnored(makeKeycloak(options));
                }, function (error) {
                  if (options.verbose) console.log('[VUE_KEYCLOAK][ERROR]: ', error);
                }));
              }
            });
          }
        });
      }
    });
  }));
}

var index = {
  install: install
};

exports["default"] = index;
exports.install = install;
